
import { FormState__startLoading, FormState__setValidationResponse_5219762A, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { SystemRoleSettingsProps, Msg, State } from "./Types.js";
import { Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { SystemRoleSettingsDto_$reflection } from "../../Shared/Roles.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";

export function init(accountSettings) {
    return [new State(new RequestedValue$1(0, []), FormState_get_empty()), accountSettings.RolesEnabled ? Cmd_none() : Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), SystemRoleSettingsDto_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), "/api/roles/system-settings", (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(3, [Item_1])))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 1:
            return [new State(new RequestedValue$1(1, [msg.fields[0]]), FormState_get_empty()), Cmd_none()];
        case 2: {
            const response_2 = msg.fields[0];
            if (response_2.tag === 1) {
                const validationResponse = response_2.fields[0];
                let globalValidationToast;
                const matchValue_1 = validationResponse.GlobalValidationMessage;
                globalValidationToast = ((matchValue_1 == null) ? Cmd_errorToast("validation.toast") : Cmd_errorToast(matchValue_1));
                return [new State(state.Settings, FormState__setValidationResponse_5219762A(state.FormState, validationResponse)), Cmd_batch(ofArray([globalValidationToast, Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_5;
                    return ((url_5 = addPrefix(url_3), (refreshOn_1) => fetchWithDecoder(url_5, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_3) => {
                        const pr_1 = response_3.arrayBuffer();
                        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), SystemRoleSettingsDto_$reflection()));
                    }, refreshOn_1)))(true).then((_arg) => {
                        const result_2 = _arg;
                        return (result_2.tag === 1) ? (Promise.resolve((() => {
                            throw new ValidationOnGetRequest(result_2.fields[0]);
                        })())) : (Promise.resolve(result_2.fields[0]));
                    });
                })), "/api/roles/system-settings", (Item_2) => (new Msg(1, [Item_2])), (Item_3) => (new Msg(3, [Item_3])))]))];
            }
            else {
                return [new State(new RequestedValue$1(1, [response_2.fields[0]]), FormState_get_empty()), Cmd_successToast("settings.permissions_changed_successful")];
            }
        }
        case 3:
            return [new State(state.Settings, FormState_get_empty()), Cmd_none()];
        default: {
            const matchValue = state.Settings;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                const updated = msg.fields[0](matchValue.fields[0]);
                return [new State(new RequestedValue$1(1, [updated]), FormState__startLoading(state.FormState)), Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(tupledArg[0]), (refreshOn) => fetchWithDecoder(url_2, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), SystemRoleSettingsDto_$reflection()));
                    }, refreshOn)))(true);
                })), ["/api/roles/system-settings", toString(0, Auto_generateBoxedEncoder_437914C6(SystemRoleSettingsDto_$reflection(), undefined, undefined, undefined)(updated))], (Item) => (new Msg(2, [Item])), (Item_1) => (new Msg(3, [Item_1])))];
            }
        }
    }
}

export function toProps(accountSettings, state, dispatch) {
    const matchValue = state.Settings;
    let matchResult, settings_1;
    if (matchValue.tag === 0) {
        matchResult = 1;
    }
    else if (!accountSettings.RolesEnabled) {
        matchResult = 0;
        settings_1 = matchValue.fields[0];
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new SystemRoleSettingsProps(settings_1, state.FormState, (arg) => {
                dispatch(new Msg(0, [arg]));
            });
        default:
            return undefined;
    }
}

